import { useEffect, useState } from "react";
import { api } from "../lib/api";

let cache = null;

export function useTopics() {
  const [topics, setTopics] = useState(cache || []);
  useEffect(() => {
    if (cache) return;
    api.get("/config").then(({ data }) => {
      cache = data.topics;
      setTopics(cache);
    });
  }, []);
  return topics;
}
